<template>
    <div>
        <div class="caja-anuncio">
            <div class="anuncio">
                <i class="fas fa-bell campana"></i>  
                <router-link class="parpadea" to="/Web/NotificacionEdictos"> Nuevos Edictos Juzgados Laborales,Familiares y Civiles </router-link>
            </div>
        </div>
    </div>
</template>

<script>


export default{

    data(){
        return{
            anuncios:[]
        }
    },

    methods:{

        CargarAnuncios:async function(){
            this.anuncios = [{Texto:"Prueba de Anuncio numero Uno"},{Texto:"Prueba de Anuncio numero Dos"},{Texto:"Prueba de Anuncio numero Tres"}]
        }

    }

}


</script>

<style scoped>
.campana{
    color:#eeac3a
  }
  .anuncio{
    background-color:white;
    width: 50%;
    height: 35px; 
    margin: auto;
    color: black;
    font-size: 2em;
    text-align: center;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    border-radius: 10px;
  }
  .caja-anuncio{
    background-color: rgb(126,127,116);
    width: 100%;
    height: 35px;
   
  }

  
  .parpadea {
  animation-name: parpadeo;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name:parpadeo;
  -webkit-animation-duration: 2s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}

  @-moz-keyframes parpadeo{  
    0% {opacity: 1.0; }
    50% { opacity: 0.5;}
    100% { opacity: 1.0;}
  }

  @-webkit-keyframes parpadeo {  
    0% {opacity: 1.0; }
    50% { opacity: 0.5;}
    100% { opacity: 1.0;}
  }

  @keyframes parpadeo {  
    0% { opacity: 1.0; color: #be9a5e; }
    50% { opacity: 0.5; color: #be9a5e; }
    100% { opacity: 1.0; color: #be9a5e; }
  }

</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/Comun/MenuSuperior/MenuAnuncios.vue